/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Sessions_TitleInputs */

const en_coaching_sessions_title = /** @type {(inputs: Coaching_Sessions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your sessions`)
};

const id_coaching_sessions_title = /** @type {(inputs: Coaching_Sessions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi kamu`)
};

/**
* | output |
* | --- |
* | "Your sessions" |
*
* @param {Coaching_Sessions_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_sessions_title = /** @type {((inputs?: Coaching_Sessions_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Sessions_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_sessions_title(inputs)
	return en_coaching_sessions_title(inputs)
});